import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {Button, Container, Toolbar} from "@material-ui/core";
import React, {useContext} from "react";
import {Flag, RecordVoiceOver} from "@material-ui/icons";
import {COMMUNICATOR_CREATE_COMMENT_PAGE_PATH, EVENT_UPDATE_PAGE_PATH} from "../../../layouts/navigation/Navigator";
import {useNavigate, useLocation} from "react-router-dom";
import Loader from "../Loader";
import {AuthorizedContext} from "../../../context/AuthorizedContext";
import {SHIPMENT_PERMISSIONS} from "../../../constants/ShipmentPermissionsConstants";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            top: 'auto',
            bottom: 0,
            backgroundColor: "#fafafa",
            paddingBottom: 8,
            "& .MuiToolbar-root": {
                justifyContent: "space-around",
                minHeight: 0,
                padding: 5
            },
            "& .MuiButtonBase-root": {
                width: 150
            }
        },
    }),
);


type AddEventCommentButtonsToolbarProps = {
    uuid: string,
    shipmentId: number | undefined
};

const AddEventCommentButtonsToolbar: React.FC<AddEventCommentButtonsToolbarProps> = ({uuid, shipmentId}) => {

    const {t} = useTranslation();
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const {hasPermission} = useContext(AuthorizedContext);

    if (!shipmentId) {
        return <Loader/>
    }


    return (<div className={classes.appBar}>
            <Container maxWidth="xs">
                <Toolbar>
                    {hasPermission(SHIPMENT_PERMISSIONS.MILESTONE_LIST) && <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth={false}
                        startIcon={<Flag/>}
                        onClick={() => navigate({
                            pathname: [EVENT_UPDATE_PAGE_PATH, uuid, shipmentId].join("/"),
                            search: `redirect=${encodeURIComponent(location.pathname + location.search)}`
                        })}
                    >{t("buttons.add-event")}</Button>}
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        fullWidth={false}
                        startIcon={<RecordVoiceOver/>}
                        onClick={() => navigate({
                            pathname: [COMMUNICATOR_CREATE_COMMENT_PAGE_PATH, uuid, shipmentId].join("/"),
                            search: `redirect=${encodeURIComponent(location.pathname + location.search)}`
                        })}
                    >{t("buttons.add-comment")}</Button>


                </Toolbar>
            </Container>
        </div>
    );
};

export default AddEventCommentButtonsToolbar;
